import React from "react";
import "./Sidebar.css";

export type NavigationPage = "home" | "search-artifacts" | "verify-messages" | "explorer";

interface SidebarProps {
  currentPage: NavigationPage;
  onNavigate: (page: NavigationPage) => void;
  isMobileMenuOpen?: boolean;
  onCloseMobileMenu?: () => void;
}

// SVG Icons matching Figma design
const HomeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9.5L12 3L21 9.5V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ArtifactsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 19L2 12L11 5V10C17 10 21 11 22 17C19 14 16 13 11 13V19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const VerifyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ExplorerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
    <path d="M2 12H22" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 2C14.5 4.5 16 8 16 12C16 16 14.5 19.5 12 22C9.5 19.5 8 16 8 12C8 8 9.5 4.5 12 2Z" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const menuItems: { id: NavigationPage; label: string; icon: React.ReactNode }[] = [
  { id: "home", label: "Home", icon: <HomeIcon /> },

];

const Sidebar: React.FC<SidebarProps> = ({
  currentPage,
  onNavigate,
  isMobileMenuOpen = false,
  onCloseMobileMenu,
}) => {
  return (
    <>
      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div className="sidebar-overlay" onClick={onCloseMobileMenu} />
      )}

      <aside className={`sidebar ${isMobileMenuOpen ? "sidebar--mobile-open" : ""}`}>
        {/* Logo */}
        <div className="sidebar__logo">
          <img src="/magnus.png" alt="MAGNUS" className="sidebar__logo-image" />
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar__menu">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`sidebar__menu-item ${currentPage === item.id ? "sidebar__menu-item--active" : ""}`}
              onClick={() => {
                onNavigate(item.id);
                onCloseMobileMenu?.();
              }}
            >
              <span className="sidebar__menu-icon">{item.icon}</span>
              <span className="sidebar__menu-label">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Footer */}
        <footer className="sidebar__footer">
 
          <div className="sidebar__copyright">
            <p>&copy; 2026 MAGNUS, Inc.</p>
            <p>All rights reserved.</p>
          </div>
        </footer>
      </aside>
    </>
  );
};

export default Sidebar;
